import { useMemo } from 'react';
import BigNumber from 'bignumber.js';

import { useGetMainTokenUSDRatioQuery } from 'modules/api/actions/getMainTokenUSDRatio';
import { useGetStakeTokenUSDRatio } from 'modules/api/hooks/useGetStakeTokenUSDRatio';

export function useGetUSDAmount(
  amount?: BigNumber,
  token: 'MAT' | 'stMAT' = 'MAT',
): BigNumber | undefined {
  const { data: mainTokenRatio } = useGetMainTokenUSDRatioQuery();
  const stakeTokenRatio = useGetStakeTokenUSDRatio();

  return useMemo(() => {
    const ratio = (() => {
      switch (token) {
        case 'stMAT':
          return stakeTokenRatio;
        case 'MAT':
        default:
          return mainTokenRatio;
      }
    })();

    return amount && ratio && amount.multipliedBy(ratio);
  }, [amount, mainTokenRatio, stakeTokenRatio, token]);
}
